import { NameDto } from '../../Common/Types'

export interface WelcomeTradingAccountDto {
  id: string
  name: string | null
  form: WelcomeTradingAccountFormDto
  accountGroupServerId: string
  accountGroup: NameDto
  server: NameDto
  leverage: NameDto
  tickmillCompany: NameDto
  lead: NameDto
  currency: NameDto
  status: NameDto
  created: string
  updated: string
  selected: boolean
}

interface WelcomeTradingAccountFormDto {
  firstName: string | null
  lastName: string | null
  email: string | null
  birthday: string
}

export enum WelcomeTradingAccountKey {
  id = 'id',
  name = 'name',
  lead = 'lead.name',
  accountGroup = 'accountGroup.name',
  // TODO: backend in progress
  accountType = '',
  status = 'status.name',
  company = 'tickmillCompany.name',
  country = 'country.name',
  createdDate = 'created',
  updatedDate = 'updated',
  platformType = 'platformType.name',
}

export enum WelcomeTradingAccountFilterKey {
  name = 'TradingAccountName',
  lead = 'LeadId',
  accountGroup = 'AccountGroupId',
  // TODO: backend in progress
  accountType = '',
  company = 'TickmillCompanyId',
  status = 'Status',
  country = 'Country',
}
